import { createContext } from 'react'
import { AlertModel } from 'src/shared/machine/alertMachine/model'
import { PermissionData } from 'src/shared/services/getAccountPermission/model'

export interface Menu {
  icon: string
  path: string
  name: string
  active: boolean
  key: string
}

export interface Props {
  /**
   * Injected by the documentation to work in an iframe.
   * You won't need it on your project.
   */
  // eslint-disable-next-line react/require-default-props
  window?: () => Window
}

export interface resetPasswordProps {
  setIsPasswordOpen?: React.Dispatch<React.SetStateAction<boolean>>
}

export const ResetPasswordType = createContext<resetPasswordProps>({})

export type AlertAuthProps = (message: AlertModel) => void

export const AlertUnauthContext = createContext<AlertAuthProps>(function () {
  return
})

export interface PermissionProps {
  permissionData?: string[]
  canAddAccount?: boolean
  canEditAccount?: boolean
  userPermission?: PermissionData
  canSendMail?: boolean
}

export const PermissionContext = createContext<PermissionProps | null>(null)

export const lenProductType = ['O', 'R', 'S', 'M', 'H']

export const productId_name: { [key: string]: { id: number; label_ch: string; label_en: string } } = {
  '1': {
    id: 1,
    label_ch: '角膜塑鏡片 OK',
    label_en: 'Ortho-K lens',
  },
  '2': {
    id: 2,
    label_ch: '硬式隱形眼鏡 RGP',
    label_en: 'RGP lens',
  },
  '3': {
    id: 3,
    label_ch: '軟式隱形眼鏡',
    label_en: 'Soft contact lens',
  },
  '4': {
    id: 4,
    label_ch: '日本目立康鏡片',
    label_en: 'Menicon',
  },
  '5': {
    id: 5,
    label_ch: '軟硬式鏡片',
    label_en: 'Hybrid lens',
  },
  '6': {
    id: 6,
    label_ch: '藥水',
    label_en: 'Contact lens care products',
  },
  '7': {
    id: 7,
    label_ch: '周邊',
    label_en: 'Accessories',
  },
  '8': {
    id: 8,
    label_ch: '配件包',
    label_en: 'Kit bag',
  },
}
